export function updateJob(data) {
    let { updateJobRequest, updateJobError, updateJobResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'update_job',
        this.createBundle('update_job', { job: data }, this.POST, updateJobRequest, updateJobResult, updateJobError)
    )
}
